import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { initialState } from 'src/context/initialState';
import { UserContextProvider } from 'src/context/userContext';
import { ApiContextProvider } from 'src/context/apiContext';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { I18nProvider } from '@cloudscape-design/components/i18n';
import enMessages from '@cloudscape-design/components/i18n/messages/all.en';
import { router } from './routes';

import '@cloudscape-design/global-styles/index.css';
import './index.scss';

import '@tanstack/react-query';
import { ToastMessageContextProvider } from 'src/context/toastMessageContext';

declare module '@tanstack/react-query' {
  interface Register {
    defaultError: Error;
  }
}

const container = document.getElementById('root');
if (!container) {
  console.error('Missing #root element in DOM');
} else {
  const root = createRoot(container);

  const queryClient = new QueryClient();

  root.render(
    <StrictMode>
      <I18nProvider messages={[enMessages]}>
        <UserContextProvider value={initialState.user}>
          <ApiContextProvider value={initialState.apiData}>
            <ToastMessageContextProvider>
              <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
              </QueryClientProvider>
            </ToastMessageContextProvider>
          </ApiContextProvider>
        </UserContextProvider>
      </I18nProvider>
    </StrictMode>,
  );
}
